import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        VMenu,
        {
          attrs: {
            "open-on-hover": "",
            bottom: "",
            "offset-y": "",
            "open-delay": "300",
            "close-delay": "100",
            "close-on-content-click": false,
            disabled: !_vm.item.query_stats,
            "max-width": "360",
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "div",
                    _vm._g(_vm._b({}, "div", attrs, false), on),
                    [
                      _c(
                        VListItem,
                        { key: _vm.item.name },
                        [
                          _c(
                            VListItemContent,
                            [
                              _c(VListItemTitle, {
                                attrs: { primary: "" },
                                domProps: {
                                  textContent: _vm._s(_vm.item.titulo),
                                },
                              }),
                              _c(
                                VListItemSubtitle,
                                { staticClass: "text--primary" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.item.proyecto) +
                                      "." +
                                      _vm._s(_vm.item.dataset) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                VListItemSubtitle,
                                { staticClass: "text--primary" },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.$t("search.description")) + ":"
                                    ),
                                  ]),
                                  _vm._v(" " + _vm._s(_vm.item.description)),
                                ]
                              ),
                              _c(
                                VListItemSubtitle,
                                { staticClass: "text--primary" },
                                [
                                  _c("b", [_vm._v("Data Operator:")]),
                                  _vm._v(" " + _vm._s(_vm.item.data_operator)),
                                ]
                              ),
                              _c(
                                VListItemSubtitle,
                                { staticClass: "text--primary" },
                                [
                                  _c("b", [_vm._v("Dominio:")]),
                                  _vm._v(" " + _vm._s(_vm.item.dominio)),
                                ]
                              ),
                              _c(
                                VListItemSubtitle,
                                { staticClass: "text--primary" },
                                [
                                  _c("b", [_vm._v("Columnas:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatNumber(_vm.item.numColumns)
                                      )
                                  ),
                                ]
                              ),
                              _c(
                                VListItemSubtitle,
                                { staticClass: "text--primary" },
                                [
                                  _c("b", [_vm._v("Tamaño:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.formatBytes(_vm.item.numBytes))
                                  ),
                                ]
                              ),
                              _c(
                                VListItemSubtitle,
                                { staticClass: "text--primary" },
                                [
                                  _c("b", [_vm._v("Filas:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.formatNumber(_vm.item.numRows))
                                  ),
                                ]
                              ),
                              _vm.item.partition
                                ? _c(
                                    VListItemSubtitle,
                                    { staticClass: "text--primary" },
                                    [
                                      _c("b", [_vm._v("Particiones:")]),
                                      _vm._v(
                                        ' "' +
                                          _vm._s(_vm.item.partition.field) +
                                          '"'
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.item.distance !== undefined
                                ? _c(
                                    VListItemSubtitle,
                                    [
                                      _c("b", [_vm._v("Similitud semántica:")]),
                                      _c(
                                        VChip,
                                        {
                                          staticClass: "mx-1",
                                          attrs: {
                                            "x-small": "",
                                            color: _vm.similarityColor(
                                              _vm.item.distance
                                            ),
                                            dark: "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.similarityPercent(
                                                  _vm.item.distance
                                                )
                                              ) +
                                              "% "
                                          ),
                                        ]
                                      ),
                                      _c(VProgressLinear, {
                                        staticStyle: {
                                          "max-width": "120px",
                                          display: "inline-flex",
                                          "vertical-align": "middle",
                                        },
                                        attrs: {
                                          value: _vm.similarityPercent(
                                            _vm.item.distance
                                          ),
                                          color: _vm.similarityColor(
                                            _vm.item.distance
                                          ),
                                          height: "4",
                                          rounded: "",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c(VListItemSubtitle, [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("search.found_in")) +
                                          " " +
                                          _vm._s(_vm.item.field) +
                                          ":"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(_vm.item.snippet),
                                      },
                                    }),
                                  ]),
                            ],
                            1
                          ),
                          _c(VListItemAction, [
                            _c(
                              "div",
                              { staticClass: "text-center" },
                              [
                                _c(
                                  VBtn,
                                  {
                                    staticClass: " mr-1",
                                    class: "color-" + _vm.item.tipo_objeto,
                                    attrs: { "x-small": "", dark: "" },
                                  },
                                  [_vm._v(_vm._s(_vm.item.tipo_objeto))]
                                ),
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "btn-inca",
                                    attrs: { "x-small": "", icon: "" },
                                  },
                                  [
                                    _vm.item.source == "synapse"
                                      ? _c(VImg, {
                                          staticClass: "pl-1",
                                          attrs: {
                                            src: require("@/assets/synapse-icon.svg"),
                                            alt: "My Icon",
                                            width: "25",
                                            height: "25",
                                          },
                                        })
                                      : _c(VImg, {
                                          staticClass: "pl-1",
                                          attrs: {
                                            src: require("@/assets/bigquery-icon.svg"),
                                            alt: "My Icon",
                                            width: "25",
                                            height: "25",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "text-center" },
                              [
                                _vm.showView
                                  ? _c(
                                      VBtn,
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          "x-small": "",
                                          outlined: "",
                                          color: "secondary",
                                          dark: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onVerObjeto(_vm.item)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("search.view")))]
                                    )
                                  : _vm._e(),
                                _vm.check_access_function(
                                  _vm.item.source,
                                  _vm.item.dominio
                                )
                                  ? _c(
                                      VBtn,
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          "x-small": "",
                                          outlined: "",
                                          color: "secondary",
                                          dark: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onRequestObjeto(_vm.item)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("search.request")))]
                                    )
                                  : _vm._e(),
                                _vm.showChange
                                  ? _c(
                                      VBtn,
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          "x-small": "",
                                          outlined: "",
                                          color: "secondary",
                                          dark: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onChangeObjeto(_vm.item)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("search.change")))]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            VCard,
            { staticClass: "pa-3", attrs: { width: "340" } },
            [
              _c(
                "div",
                { staticClass: "d-flex align-center mb-2" },
                [
                  _c(
                    VIcon,
                    {
                      staticClass: "mr-1",
                      attrs: { small: "", color: "primary" },
                    },
                    [_vm._v("mdi-chart-line")]
                  ),
                  _c("span", { staticClass: "caption font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.$t("search.stats_title"))),
                  ]),
                  _c(VSpacer),
                  _vm.item.query_stats && _vm.item.query_stats.computed_at
                    ? _c(
                        VTooltip,
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      VIcon,
                                      _vm._g(
                                        _vm._b(
                                          { attrs: { "x-small": "" } },
                                          "v-icon",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [_vm._v("mdi-information-outline")]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            940506911
                          ),
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("search.stats_computed_at", {
                                  fecha: _vm.formatLocalDate(
                                    _vm.item.query_stats.computed_at
                                  ),
                                })
                              )
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.item.query_stats && _vm.item.query_stats.queries_30d
                ? [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-space-between caption mb-1",
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "grey--text text--darken-1" },
                          [_vm._v(_vm._s(_vm.$t("search.stats_queries_30d")))]
                        ),
                        _c("b", [
                          _vm._v(
                            _vm._s(
                              _vm.formatNumber(_vm.item.query_stats.queries_30d)
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-space-between caption mb-1",
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "grey--text text--darken-1" },
                          [_vm._v(_vm._s(_vm.$t("search.stats_users_30d")))]
                        ),
                        _c("b", [
                          _vm._v(
                            _vm._s(
                              _vm.formatNumber(_vm.item.query_stats.users_30d)
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-space-between caption mb-1",
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "grey--text text--darken-1" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("search.stats_last_queried_at"))
                            ),
                          ]
                        ),
                        _c("b", [
                          _vm._v(
                            _vm._s(
                              _vm.formatLocalDate(
                                _vm.item.query_stats.last_queried_at
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-space-between caption" },
                      [
                        _c(
                          "span",
                          { staticClass: "grey--text text--darken-1 mr-2" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("search.stats_last_queried_by"))
                            ),
                          ]
                        ),
                        _c(
                          VTooltip,
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "b",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticStyle: {
                                                "max-width": "190px",
                                                overflow: "hidden",
                                                "text-overflow": "ellipsis",
                                                "white-space": "nowrap",
                                              },
                                            },
                                            "b",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.item.query_stats
                                                .last_queried_by
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1778522525
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.item.query_stats.last_queried_by)
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                : _c("div", { staticClass: "caption grey--text" }, [
                    _vm._v(" " + _vm._s(_vm.$t("search.stats_empty")) + " "),
                  ]),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }